import React, { useState } from "react";
import { format } from "date-fns";
import DateFilterModal from "./Sales Crm Modal/DateFilterModal";

const DateFilterComponent = ({ setDateForApi }) => {
  const [dateFilterModalOpen, setDateFilterModalOpen] = useState(false);
  const [date, setDate] = useState(null); // Initially null (no date selected)

  const handleCloseDateFilterModal = () => {
    setDateFilterModalOpen(false);
  };

  const handleDateChange = (ranges) => {
    setDate(ranges); // Save selected date range
    setDateForApi(ranges); // Send to parent or API
  };

  return (
    <>
      <div
        className="col-sm-2 mt-3"
        style={{ display: "flex", justifyContent: "center" }}
      >
        <div>
          <label>Date Filter</label>
          <div>
            <button
              style={{
                fontSize: "12px",
              }}
              onClick={() => setDateFilterModalOpen(true)}
              className="btn btn-outline-success"
            >
              {date
                ? `${format(date.startDate, "MMM dd yyyy")} -- ${format(
                    date.endDate,
                    "MMM dd yyyy"
                  )}`
                : "Select Calender Date"}
            </button>
          </div>
        </div>
      </div>

      <DateFilterModal
        dateFilterModalOpen={dateFilterModalOpen}
        handleCloseDateFilterModal={handleCloseDateFilterModal}
        date={date}
        onDateChange={handleDateChange}
      />
    </>
  );
};

export default DateFilterComponent;
